import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from './modal';
import { FiCheckCircle } from 'react-icons/fi';
const SuccessModal = ({ isOpen, headerText, infoText, onCloseHandler, blockScroll, children, className }) => {
  useEffect(() => {
    const keyDownHandler = event => {
      if (isOpen && event.key === 'Escape') {
        event.preventDefault();
        onCloseHandler();
      }
    };
    document.addEventListener('keydown', keyDownHandler);
    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  });

  return (
    <Modal isOpen={isOpen} onCloseHandler={onCloseHandler} blockScroll={blockScroll}>
      <div className={`lf-modal-success__container ${className}`}>
        <FiCheckCircle className="lf-modal-success__icon mb-5x" />
        <h5 className="lf-text-center lf-text-medium pb-2x">{headerText}</h5>
        <p className="lf-text-center mb-6x">{infoText}</p>
        {children}
      </div>
    </Modal>
  );
};

SuccessModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  headerText: PropTypes.string,
  infoText: PropTypes.string,
  onCloseHandler: PropTypes.func,
  blockScroll: PropTypes.bool,
  children: PropTypes.element,
  className: PropTypes.string,
};
SuccessModal.defaultProps = {
  headerText: '',
  infoText: '',
  onCloseHandler: () => {},
  blockScroll: false,
  className: '',
};

export default SuccessModal;
